import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import NProgress from "nprogress"
import 'nprogress/nprogress.css'
import store from "@/store"; //这个样式必须引入

Vue.use(NProgress)
Vue.use(VueRouter)

const router = new VueRouter({
    scrollBehavior: () => ({y: 0}),
    // mode: 'history',
    // base:'/h5/',
    routes,
})

router.beforeEach((to, from, next) => {


    // if(to.query){
    //     store.commit('SET_QUERY_PARAMS', to.query)
    // }
//     document.body.scrollTop = 0;
//     document.documentElement.scrollTop = 0;
//     // window.pageYOffset = 0;
//
//     if (to.meta.title) {
//         document.title = `${to.meta.title}`
//     }
// // eslint-disable-next-line no-debugger
// //     debugger
    if (to.fullPath.indexOf('/admin') >= 0 && to.fullPath.indexOf('/login') < 0) {
        // NProgress.start()
        let token = window.localStorage.getItem("token");
        if (token && token.length > 0) {
            next()

        } else {
            next({path: '/login'})
        }

    } else {
        next()
    }

})

router.afterEach(() => {
    // window.scrollTo(0,0);
    NProgress.done();
})

export default router
